/*
 * Service customerInfoFilter
 */
angular
  .module('posApp')
  .factory('customerInfoFilterOptions', (translate: any) => {
    const $translate = translate;

    return [
      {
        type: null,
        name: $translate.instant('All'),
      },
      {
        type: 2,
        name: $translate.instant('Sales'),
      },
      {
        type: 9,
        status: 'open',
        name: $translate.instant('open_consignment'),
      },
      {
        type: 9,
        status: 'closed',
        name: $translate.instant('closed_consignment'),
      },
    ];
  });
